import GridViewIcon from "@mui/icons-material/GridView";
import { SvgIconProps } from "@mui/material";

const Dashboard = (props: SvgIconProps) => {
  return <GridViewIcon {...props} />;
};

export default Dashboard;
